import { ScheduledAutomationField } from '@shared/data/entity/fields/ScheduledAutomationField';
import { DurationsTextView } from '@shared/scenes/entity/components/fields/ScheduledAutomationEditField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: ScheduledAutomationField;
}

export function ScheduledAutomationCollectionViewField({ field }: Props) {
  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <DurationsTextView durations={field.durations} />
    </CardCollectionViewFieldContainer>
  );
}
